export enum TemplateType {
  Internal = "internal",
  External = "external",
  Shared = "shared",
}
